<template>
	<div class="w-full grid grid-cols-3 gap-1 ml-4">
		<div class="flex items-center" v-for="(value, propertyName, index) in charlson.conditions" :key="index">
      <input id="injection_steriod" type="checkbox" v-model="charlson.conditions[propertyName]" @change="$emit('change', charlson)" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
      <label for="injection_steriod'" class="ml-2 block text-sm text-gray-900">
        {{ propertyName }}
      </label>
    </div>
	</div>
</template>

<script>
export default {
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      charlson: {
        conditions: {
          'Myocardial infarction': false,
          'Congestive heart failure': false,
          'Peripheral vascular disease': false,
          'Cerebrovascular disease': false,
          'Dementia': false,
          COPD: false,
          'Connective Tissue Disease': false,
          'Peptic ulcer disease': false,
          'Diabetes with end organ damage': false,
          'Diabetes without end organ damage': false,
          'Chronic Kidney Disease - moderate to severe': false,
          Hemiplegia: false,
          Leukaemia: false,
          Lymphoma: false,
          'Moderate or severe liver disease': false,
          'Any malignancy without metastasis': false,
          'Metastatic solid tumour': false,
          AIDS: false
        }
      }
    }
  },
  created() {
    for (const cond in this.value.conditions) {
      if (this.value.conditions[cond]) this.charlson.conditions[cond] = true
    }
  }
}
</script>
